import React from 'react';
import { ProgressiveSignup } from '@/components/signup/ProgressiveSignup';

interface InitialFormData {
  name: string;
  age: string;
  state: string;
  coverageAmount: string;
  smokingStatus: string;
}

interface AccountCreationProps {
  initialData: InitialFormData;
  onAccountCreated: (user: any) => void;
}

export const AccountCreation: React.FC<AccountCreationProps> = ({ initialData, onAccountCreated }) => {
  return (
    <ProgressiveSignup 
      initialData={initialData}
      onSignupComplete={onAccountCreated}
    />
  );
};